import React, { useCallback, useState, useEffect, useMemo } from 'react';

import { useUserContext } from 'providers/UserProvider';

import Table from 'components/common/Table';

import { shipmentApi } from 'api';

import {
  getShipmentListTab,
  getShipmentListColumns,
  SHIPMENT_FILTER_OPTIONS,
} from 'constants/shipment';
import { FILTER_TYPES } from 'constants/filterType';

const Shipment = () => {
  const { selectedTenant, selectedWarehouse } = useUserContext();
  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;

  const initialFilter = { warehouse: selectedWarehouse?.id };

  const [shippingProviders, setShippingProviders] = useState([]);

  useEffect(() => {
    const fetchProviders = async () => {
      try {
        const response = await shipmentApi.getShippingProviders();
        const results = response?.results || response || [];
        setShippingProviders(results);
      } catch {
        setShippingProviders([]);
      }
    };
    fetchProviders();
  }, []);

  const filterOptions = useMemo(() => {
    const providerOptions = shippingProviders.map(p => ({
      value: p.id,
      label: p.shipping_provider_type,
    }));

    return [
      ...SHIPMENT_FILTER_OPTIONS.slice(0, -1),
      {
        field: 'shipping_provider',
        label: 'Shipping Provider',
        type: FILTER_TYPES.MULTI_SELECT,
        options: providerOptions,
      },
      SHIPMENT_FILTER_OPTIONS[SHIPMENT_FILTER_OPTIONS.length - 1],
    ];
  }, [shippingProviders]);

  const exportApi = useCallback(params => {
    return shipmentApi.exportShipment(params);
  }, []);

  return (
    <Table
      title="Shipments"
      apiService={shipmentApi}
      exportApi={exportApi}
      sortable={true}
      columns={getShipmentListColumns(tenant, warehouse)}
      filterOptions={filterOptions}
      tabOptions={getShipmentListTab(initialFilter)}
      initialFilter={initialFilter}
    />
  );
};

export default Shipment;
